<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">table_chart</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Tabela de alíquota IBS por UF</h2>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <mat-form-field appearance="outline" class="w-100 search-field" subscriptSizing="dynamic">
        <mat-label>Pesquisar UF</mat-label>
        <input matInput type="text" [(ngModel)]="pesquisa" (ngModelChange)="filtrar()" placeholder="Sigla ou nome da UF...">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    @if (isLoading) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
    <div class="desktop-view">
    <table mat-table [dataSource]="linhas" class="w-100">
        <ng-container matColumnDef="uf">
            <th mat-header-cell *matHeaderCellDef>UF</th>
            <td mat-cell *matCellDef="let row">
                <span class="status-badge badge-cinza">{{ row.nome }} - {{ row.uf }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="aliquota">
            <th mat-header-cell *matHeaderCellDef>Alíquota</th>
            <td mat-cell *matCellDef="let row">
                <span class="status-badge" [class.badge-azul]="row.personalizada" [class.badge-cinza]="!row.personalizada">
                    {{ row.pAliquota }}%
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="vigencia">
            <th mat-header-cell *matHeaderCellDef>Período de Vigência</th>
            <td mat-cell *matCellDef="let row" class="text-secondary" style="font-size:0.85rem;">
                {{ row.dataVigenciaInicio ? (row.dataVigenciaInicio | date:'dd/MM/yyyy') : '—' }} - {{ row.dataVigenciaFim ? (row.dataVigenciaFim | date:'dd/MM/yyyy') : 'Permanente' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
            <td mat-cell *matCellDef="let row" class="text-center">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="editar(row)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>

    <div class="mobile-view">
        @for (row of linhas; track row.idUnidadeFederativa) {
        <div class="card-mobile mb-3">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
                <span class="status-badge badge-cinza">{{ row.nome }} - {{ row.uf }}</span>
                <button mat-icon-button [matMenuTriggerFor]="menuMobUf" aria-label="Ações">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuMobUf="matMenu">
                    <button mat-menu-item (click)="editar(row)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
                <p class="mb-2">
                    <strong>Alíquota:</strong>
                    <span class="status-badge ms-1" [class.badge-azul]="row.personalizada" [class.badge-cinza]="!row.personalizada">{{ row.pAliquota }}%</span>
                </p>
                <p class="mb-0">
                    <strong>Período de Vigência:</strong>
                    {{ row.dataVigenciaInicio ? (row.dataVigenciaInicio | date:'dd/MM/yyyy') : '—' }} - {{ row.dataVigenciaFim ? (row.dataVigenciaFim | date:'dd/MM/yyyy') : 'Permanente' }}
                </p>
            </div>
        </div>
        }
    </div>

    @if (linhas.length === 0) {
    <app-empty-state
        icon="search_off"
        title="Nenhuma UF encontrada"
        subtitle="Ajuste o termo de pesquisa para visualizar as alíquotas de IBS por UF.">
    </app-empty-state>
    }
    }
</mat-dialog-content>
